// Research 页左栏的模拟片段。
// 转成 mp4 是为了能单独控制播放 —— GIF 没法暂停，做不到"只有中间那个在动"。
// poster 是第一帧，没播放时显示它，省流量。
// `to` 是标题点击后跳转到的右栏锚点（文章 id，见 researchData.js）。
export const reel = [
  {
    id: 'condensate',
    src: '/videos/6.mp4',
    poster: '/videos/6.jpg',
    title: 'Condensate formation',
    caption: 'A coarse-grained model for EB1 protein.',
    to: 'eb1-2023',
  },
  {
    id: 'stress-granule',
    src: '/videos/7.mp4',
    poster: '/videos/7.jpg',
    title: 'Multivalent binding network',
    caption: 'G3BP1 and RNA percolating into a stress granule.',
    to: 'ijbm-2024',
  },
  {
    id: 'amyloid',
    src: '/videos/asyn.mp4',
    poster: '/videos/asyn.jpg',
    title: 'α-Synuclein amyloid stability',
    caption: 'Mimic AFM experiments.',
    to: 'aggregate-2025-method',
  },
  {
    id: 'nanowire',
    src: '/videos/1.mp4',
    poster: '/videos/1.jpg',
    title: 'Nanowire',
    caption: 'Metal ions binding nanowires into an aerogel.',
    to: 'small-2021',
  },
  // 暂时撤下，文件还在 public/videos/bfactor.mp4，要用时去掉注释即可
  // {
  //   id: 'globular',
  //   src: '/videos/bfactor.mp4',
  //   poster: '/videos/bfactor.jpg',
  //   title: 'Globular protein condensation grammar',
  //   caption: 'in preparation',
  //   to: null,
  // },
];
